import type { PublishedLegalDocument } from "./content-types.ts"

export const PRIVACY_POLICY = {
  announcedAt: "2026-07-30",
  effectiveAt: "2026-07-30",
  preamble: [{ kind: "paragraph", text: "주식회사 아인아이엔씨(이하 “회사”)가 제공하는 CashHub는 이용자의 개인정보를 중요하게 생각하며 「개인정보 보호법」 등 관계 법령을 준수한다." }],
  publishable: true,
  sections: [
    {
      title: "1. 개인정보의 처리 목적, 항목 및 보유기간",
      blocks: [
        { kind: "paragraph", text: "회사는 필요한 최소한의 개인정보를 다음과 같이 처리한다. 선택 기능을 사용하지 않으면 해당 정보는 수집하지 않는다." },
        {
          kind: "table",
          label: "개인정보의 처리 목적, 항목 및 보유기간 표",
          columns: ["구분", "처리 목적", "처리 항목", "보유기간"],
          rows: [
            ["회원가입·로그인", "계정 생성, 로그인, 계정연결, 부정가입 방지", "CashHub 회원번호, 로그인 제공자, 제공자별 고유식별값, 가입·연결일, 계정상태, 약관 동의 버전·일시", "회원탈퇴 시까지. 단, 법정 보존정보는 분리보관"],
            ["Google 로그인", "Firebase 인증 토큰 검증", "Firebase UID 및 로그인 제공자 정보", "계정 연결 해제 또는 탈퇴 시까지"],
            ["본인·연령 확인", "만 14세 이상 확인, 고위험 거래 보호", "휴대전화번호, 연령확인 결과, 본인확인 연계정보(CI)는 해당 기능을 실제 도입하는 경우에만 처리", "목적 달성 또는 탈퇴 시까지. CI 보유 필요성 별도 검토"],
            ["제휴 전환", "회원 연결, 전환조건 계산, 원천 리워드 차감 확인, 중복방지, 정산·오류복구", "암호화 또는 해시된 제휴 사용자키, 제휴사·매체 식별자, 요청번호, 원천 리워드 수량, 적용률, 전환비용, 최종 적립액, 정책버전, 상태, 요청·처리시각", "거래 종료 후 5년"],
            ["통합잔액", "잔액 적립·사용·보류·복원·소멸, 거래조회, 분쟁처리", "회원번호, 원장 거래번호, 잔액 묶음, 원천 출처, 금액, 거래유형, 소멸예정일, 상태, 처리시각", "거래 종료 후 5년"],
            ["상품 교환", "상품 주문, 모바일 상품권 발행·발송·상태조회·재발송·취소", "회원번호, 상품·주문번호, 상품명, 차감액, 암호화된 수령 휴대전화번호, 공급사 주문번호, 발행·발송·사용·취소 상태, 처리시각", "계약·대금결제·재화공급 기록 5년 등 적용 법령에 따른 기간"],
            ["고객문의", "문의 접수, 본인확인, 답변, 분쟁·오류처리", "회원번호, 문의제목·내용, 관련 거래번호, 첨부파일, 처리상태, 작성·답변일", "처리 완료 후 3년"],
            ["제휴문의", "대행사·매체사·공급사 제휴 검토와 회신", "회사명, 담당자명, 업무 이메일, 문의유형, 예상규모, 문의내용, 첨부파일 및 파일 메타데이터", "접수일로부터 3년 또는 동의 철회 시까지 중 먼저 도래하는 때"],
            ["알림", "거래·보안·소멸예정·서비스 알림, 선택적 마케팅", "회원번호, 알림 제목·내용, 읽음 여부, 수신설정, 푸시토큰, 발송채널·상태·시각", "탈퇴 또는 토큰 무효화 시까지. 발송이력은 분쟁기간까지"],
            ["보안·서비스 운영", "세션 유지, 접속관리, 장애분석, 부정이용 방지", "세션·리프레시 토큰의 해시값, 쿠키, IP주소, 사용자 에이전트, 기기·앱 버전, 접속일시, 요청·오류·보안 로그", "원칙적으로 3개월. 사고조사·법정의무가 있으면 해당 기간"],
          ],
        },
        { kind: "paragraph", text: "CashHub는 현재 Google 이메일, Google 표시이름 및 프로필 사진을 회원 프로필로 저장하지 않는다. 향후 저장 항목이 추가되면 실제 배포 전에 이 방침과 동의화면을 먼저 변경한다." },
      ],
    },
    {
      title: "2. 개인정보 처리의 법적 근거",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회원가입, 로그인, 전환, 통합잔액 및 상품 교환에 필요한 정보: 정보주체와 체결한 계약의 이행 또는 계약 체결 과정에서 정보주체의 요청에 따른 조치",
            "선택적 마케팅, 선택적 본인확인 등 별도 동의가 필요한 정보: 정보주체의 동의",
            "거래·세무·분쟁 기록: 관계 법령상 의무 준수 또는 회사의 정당한 이익",
            "보안로그와 부정이용 방지: 안전한 서비스 제공과 이용자 재산 보호를 위한 정당한 이익",
          ],
        },
      ],
    },
    {
      title: "3. 만 14세 미만 아동",
      blocks: [{ kind: "paragraph", text: "회사는 현재 만 14세 미만 아동을 위한 법정대리인 동의 절차를 제공하지 않으며 만 14세 미만의 가입을 제한한다. 향후 아동 대상 서비스를 제공하는 경우 법정대리인 동의·확인·권리행사 절차를 먼저 마련하고 방침을 개정한다." }],
    },
    {
      title: "4. 개인정보의 제3자 제공",
      blocks: [
        { kind: "paragraph", text: "회사는 원칙적으로 정보주체의 동의 없이 개인정보를 제3자에게 제공하지 않는다. 다만 법령에 근거가 있거나 계약 이행을 위하여 필요한 범위에서 다음 처리가 발생할 수 있다." },
        {
          kind: "table",
          label: "개인정보의 제3자 제공 표",
          columns: ["제공받는 자", "제공 목적", "제공 항목", "보유기간"],
          rows: [["회원이 전환을 시작한 제휴 대행사·매체사", "회원 연결 확인, 원천 리워드 차감·복원, 전환상태 확인 및 정산", "제휴 사용자키, 전환 요청번호, 원천 리워드 수량, 처리상태, 처리시각", "제휴계약 및 관계 법령에 따른 기간"]],
        },
        { kind: "paragraph", text: "제휴사별 회사명, 제공항목, 목적, 보유기간 및 동의 필요 여부는 실제 계약이 체결되고 전환이 열릴 때 전환 확인화면 또는 별도 동의화면에서 구체적으로 안내한다. 단순 API 연동이라는 이유로 제공·위탁 관계를 임의로 정하지 않는다." },
      ],
    },
    {
      title: "5. 개인정보 처리업무의 위탁",
      blocks: [
        { kind: "paragraph", text: "회사는 원활한 서비스 제공을 위해 다음 업무를 위탁할 수 있다." },
        {
          kind: "table",
          label: "개인정보 처리업무의 위탁 표",
          columns: ["수탁자", "위탁업무", "처리 항목"],
          rows: [
            ["주식회사 케이티알파(기프티쇼 비즈)", "모바일 상품권 발행, 휴대전화 발송, 상태조회, 가능한 경우 재발송·취소", "수령 휴대전화번호, 상품코드, 주문·발송 식별정보"],
            ["Google LLC 및 Firebase 관련 계약법인", "소셜 로그인 인증, 서비스 인프라, 푸시 알림을 사용하는 경우 해당 기능 제공", "Firebase UID, 인증·접속정보, 푸시토큰 및 기기정보"],
          ],
        },
        { kind: "paragraph", text: "회사는 위탁계약에 목적 외 처리금지, 안전성 확보, 재위탁 관리, 사고통지, 감독 및 반환·파기 의무를 반영한다." },
        { kind: "paragraph", text: "KT 기프티쇼 비즈를 통한 모바일 상품권 발행 과정에서는 상품 수령을 위해 휴대전화번호가 전달될 수 있다." },
      ],
    },
    {
      title: "6. 개인정보의 국외 이전",
      blocks: [
        { kind: "paragraph", text: "Google Firebase 인증 또는 푸시 서비스를 사용하는 과정에서 다음과 같이 개인정보가 국외로 이전될 수 있다." },
        {
          kind: "table",
          label: "개인정보의 국외 이전 표",
          columns: ["이전받는 자", "이전 국가", "이전 항목", "이전 목적", "이전 시기·방법", "보유·이용기간"],
          rows: [["Google LLC", "미국", "Firebase UID, 인증·접속정보, 푸시토큰 및 기기정보", "소셜 로그인 인증, 서비스 보안, 푸시 알림", "로그인 또는 알림 기능 이용 시 암호화된 네트워크를 통한 전송", "회원탈퇴, 계정연결 해제 또는 위탁계약 종료 시까지"]],
        },
        { kind: "paragraph", text: "이용자는 개인정보 담당부서를 통해 국외이전을 거부할 수 있다. 다만 Google 로그인을 위한 국외이전을 거부하면 해당 로그인 기능을 이용할 수 없으며, 푸시정보 이전을 거부하면 푸시 알림을 받을 수 없다." },
      ],
    },
    {
      title: "7. 개인정보의 파기",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회사는 보유기간이 지나거나 처리 목적이 달성되어 개인정보가 불필요해지면 지체 없이 파기한다.",
            "다른 법령에 따라 보존해야 하는 정보는 운영 데이터와 분리하여 접근을 제한하고 정해진 목적에만 사용한다.",
            "전자파일은 복구가 어렵도록 안전한 방식으로 삭제하고, 종이문서는 분쇄 또는 소각한다.",
            "회원탈퇴 시 소셜 계정 연결과 프로필 식별정보를 제거하되, 법정 보존대상 거래원장과 감사기록은 분리보관 후 기간 만료 시 파기한다.",
            "운영 전 수집항목별 파기 배치, 예외 큐, 실행로그와 승인절차가 실제로 동작하는지 검증한다.",
          ],
        },
      ],
    },
    {
      title: "8. 정보주체와 법정대리인의 권리",
      blocks: [
        { kind: "paragraph", text: "정보주체는 자신의 개인정보에 대하여 열람, 정정·삭제, 처리정지, 동의철회 및 법령상 자동화된 결정에 대한 설명·거부를 요구할 수 있다." },
        {
          kind: "ordered-list",
          items: ["일반 계정정보: 로그인 후 내 정보", "마케팅 동의: 알림·수신설정", "계정 삭제: 로그인 후 계정 삭제", "그 밖의 권리행사: 로그인 후 1:1 문의 또는 개인정보 담당부서"],
        },
        { kind: "paragraph", text: "회사는 본인 또는 정당한 대리인인지 확인한 후 법령이 정한 기간 안에 처리한다. 법령상 보존의무가 있거나 다른 사람의 권리를 침해할 우려가 있는 경우 일부 요구가 제한될 수 있으며 그 사유를 알린다." },
      ],
    },
    {
      title: "9. 개인정보 자동 수집 장치",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회사는 로그인 상태 유지, 보안 및 서비스 기능 제공을 위해 필수 쿠키를 사용할 수 있다.",
            "웹 로그인 쿠키는 HttpOnly, Secure, SameSite 등 안전한 속성을 적용한다.",
            "브라우저 설정에서 쿠키를 차단할 수 있으나 필수 쿠키를 차단하면 로그인과 거래 기능을 이용하기 어려울 수 있다.",
            "맞춤형 광고나 행태정보를 이용하는 경우에는 실제 도입 전에 수집항목, 이용목적, 보유기간, 통제방법을 별도로 고지한다. 현재 CashHub 핵심 서비스에는 맞춤형 광고를 전제로 하지 않는다.",
          ],
        },
      ],
    },
    {
      title: "10. 개인정보의 안전성 확보조치",
      blocks: [
        { kind: "paragraph", text: "회사는 다음 보호조치를 적용한다." },
        {
          kind: "ordered-list",
          items: [
            "개인정보 보호 내부관리계획과 책임체계 수립",
            "업무상 필요한 최소 권한 부여와 관리자·파트너별 접근범위 분리",
            "휴대전화번호, 제휴 사용자키 등 중요정보의 암호화 또는 해시 처리",
            "전송구간 암호화와 인증토큰 원문 미보관",
            "관리자 활동, 권한변경, 금액조정 및 개인정보 조회 감사로그",
            "거래의 중복방지 키, 원장 반대거래, 보류·확정·복원 절차",
            "접근기록 보관과 위변조 방지",
            "취약점 점검, 비밀키 분리보관·교체, 백업 및 사고대응",
            "수탁자 계약·점검과 임직원 교육",
          ],
        },
      ],
    },
    {
      title: "11. 서비스 알림과 마케팅 정보",
      blocks: [{ kind: "paragraph", text: "거래처리, 보안, 약관 변경, 소멸예정 등 서비스 운영에 필요한 알림은 계약 이행을 위해 발송할 수 있다. 할인·이벤트 등 광고성 정보는 선택적 수신동의를 받은 채널로만 발송하며, 동의와 철회 이력을 보관한다." }],
    },
    {
      title: "12. 개인정보 보호책임자와 열람청구",
      blocks: [
        { kind: "paragraph", text: "회사는 개인정보 보호와 관련한 문의 및 권리행사를 처리하기 위해 다음과 같이 개인정보 보호책임자와 담당부서를 지정한다." },
        {
          kind: "unordered-list",
          items: ["개인정보 보호책임자: 이남규", "담당부서: CashHub 운영팀", "이메일: mediavue02@gmail.com", "고객지원 연락처: 010-7386-9363", "주소: 경기도 성남시 판교로255번길 9-22 417호"],
        },
      ],
    },
    {
      title: "13. 권익침해 구제방법",
      blocks: [
        { kind: "paragraph", text: "정보주체는 개인정보 침해에 대한 상담이나 구제를 위해 다음 기관에 문의할 수 있다." },
        {
          kind: "ordered-list",
          items: ["개인정보침해 신고센터: 국번 없이 118, privacy.kisa.or.kr", "개인정보분쟁조정위원회: 1833-6972, www.kopico.go.kr", "대검찰청: 국번 없이 1301, www.spo.go.kr", "경찰청: 국번 없이 182, ecrm.police.go.kr"],
        },
      ],
    },
    {
      title: "14. 개인정보처리방침의 변경",
      blocks: [
        {
          kind: "ordered-list",
          items: ["회사는 방침 변경 시 변경내용, 사유 및 시행일을 서비스에 공지한다.", "중요한 변경이나 별도 동의가 필요한 변경은 법령이 정한 방식으로 개별 안내하고 필요한 동의를 받는다.", "이전 버전과 변경이력을 확인할 수 있도록 제공한다."],
        },
      ],
    },
    { title: "부칙", blocks: [{ kind: "paragraph", text: "이 개인정보처리방침은 2026년 7월 30일부터 시행한다." }] },
  ],
  slug: "terms-privacy",
  title: "CashHub 개인정보처리방침",
  version: "1.0",
} as const satisfies PublishedLegalDocument
